// generated by genversion
export var version = '4.2.11';
//# sourceMappingURL=version.js.map